import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type { LicenseStatus } from '../types';

/**
 * Public license status — reachable even when the license is expired.
 * Fails open (null) on network errors so the status check itself can
 * never lock anyone out.
 */
export async function getLicenseStatus(): Promise<LicenseStatus | null> {
  try {
    const response = await apiClient.get<LicenseStatus>(
      API_ENDPOINTS.LICENSE.STATUS
    );
    return response?.data ?? null;
  } catch {
    return null;
  }
}

/**
 * Activate (or renew) the license with a signed key. Public endpoint — the
 * key is itself the credential — so this works even from the license-expired
 * page without an authenticated session. Errors (invalid/expired key) surface
 * via the global mutation error toast.
 */
export async function activateLicense(key: string): Promise<LicenseStatus> {
  const response = await apiClient.post<LicenseStatus>(
    API_ENDPOINTS.LICENSE.ACTIVATE,
    { key }
  );
  return response.data as LicenseStatus;
}
